import React from 'react'

const ExamRules = () => {
    return (
        <div>
            <h5 className="header mb-1 mt-1"> Examination Rules and Regulations </h5>
            <ol className='p-0 m-0'>
                <li className='py-1 ps-2 ms-2'>
                    All school rules must be observed throughout the entire test.
                </li>
                <li className='py-1 ps-2 ms-2'>
                    Normal lessons will resume after the Common Test
                </li>
                <li className='py-1 ps-2 ms-2'>
                         Students are required to bring their own writing
                          and mathematical instruments.  No borrowing, lending or 
                          exchange of any materials is allowed during the Common Test.
                </li>
                <li className='py-1 ps-2 ms-2'>
                    Absentees must produce original medical certificates from approved 
                    clinics or hospitals.  No parents’ letter will be accepted.
                    Students who are absent without valid reasons will 
                    be given a “0” for the paper.
                </li>
                <li className='py-1 ps-2 ms-2'>
                     Students must be seated at their assigned desks by 7.25am.
                </li>
                <li className='py-1 ps-2 ms-2'>
                    Only essential writing materials are allowed on the student’s
                    desk.  All bags, books and any unauthorised materials should 
                    be left at the front of the classroom.
                </li>
            </ol>
        </div>
    )
}

export default ExamRules
